/**
 * Custom hook to determine the language according to the configuration of the catalog
 * based system language
 * @example const getLocalizedLabel = useLocalizedLabel(); 
 */
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const useLocalizedLabel = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || "es";

  // Estable mientras no cambie el idioma: varios consumidores lo pasan como
  // dependencia de useMemo, y una identidad nueva en cada render invalidaba
  // esos memos (y con ellos los efectos que dependian de su resultado).
  const getLocalizedLabel = useCallback(
    (item) => {
      if (!item) return "";
      const { locales = {}, label } = item;
      const labelFromLocale = locales[lang] || Object.values(locales)[0];
      return labelFromLocale || label || "";
    },
    [lang]
  );

  return getLocalizedLabel;
};

export default useLocalizedLabel;
